import { useEffect, useState } from 'react';
import Ball10 from '../../../assets/Itv/Balls/ball-10.svg';
import Ball20 from '../../../assets/Itv/Balls/ball-20.svg';
import Ball30 from '../../../assets/Itv/Balls/ball-30.svg';
import Ball40 from '../../../assets/Itv/Balls/ball-40.svg';
import Ball50 from '../../../assets/Itv/Balls/ball-50.svg';
import Ball60 from '../../../assets/Itv/Balls/ball-60.svg';
import Ball70 from '../../../assets/Itv/Balls/ball-70.svg';
import Ball75 from '../../../assets/Itv/Balls/ball-75.svg';
import Ball80 from '../../../assets/Itv/Balls/ball-80.svg';
import Ball90 from '../../../assets/Itv/Balls/ball-90.svg';

export const ballImages: Record<number, string> = {
  10: Ball10,
  20: Ball20,
  30: Ball30,
  40: Ball40,
  50: Ball50,
  60: Ball60,
  70: Ball70,
  75: Ball75,
  80: Ball80,
  90: Ball90,
};

export const useBingoCountdown = (gameStartEpoch?: number | null): number => {
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    if (!gameStartEpoch) return;

    setNow(Date.now());

    const intervalId = window.setInterval(() => {
      const current = Date.now();

      setNow(current);

      if (current >= gameStartEpoch) {
        window.clearInterval(intervalId);
      }
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, [gameStartEpoch]);

  if (!gameStartEpoch) return -1;

  return gameStartEpoch - now;
};

export const formatTimeToStart = (ms: number): string => {
  if (ms <= 0) return '0s';

  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts: string[] = [];

  if (hours > 0) parts.push(`${hours}h`);

  if (minutes > 0) parts.push(`${minutes}m`);
  parts.push(`${seconds.toString().padStart(2, '0')}s`);

  return parts.join(' ');
};
